import { gql } from "@apollo/client";

export const GET_REALESTATE_PERSONS = gql`
    query GetRealestatePersons($realestateid: uuid!) {
        realestatepersons: common_realestatepersons(
            where: { realestateid: { _eq: $realestateid } }
            order_by: { role: asc }
        ) {
            id
            personid
            role
            person {
                legal
                name1
                name2
            }
        }
    }
`;
